import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Paragraph from '~/components/blocks/core/Paragraph';

const ParagraphBlock = ({
    attrs: { anchor, align, content, fontSize, className }
}) => <Paragraph {...{ anchor, align, content, fontSize, className }} />;

ParagraphBlock.propTypes = {
    attrs: PropTypes.shape({
        content: PropTypes.string.isRequired,
        anchor: PropTypes.string,
        align: PropTypes.string,
        fontSize: PropTypes.string,
        className: PropTypes.string
    }).isRequired
};

export default ParagraphBlock;

export const fragment = graphql`
    fragment ParagraphBlockFragment on WpCoreParagraphBlock {
        name
        attrs: attributes {
            ... on WpCoreParagraphBlockAttributes {
                anchor
                align
                content
                fontSize
                className
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Regular Paragraph',
        description: 'Font size options: Small, Regular, Large',
        props: {
            name: 'core/paragraph',
            attrs: {
                content:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
            }
        }
    },
    {
        variant: 'Small Paragraph Centered',
        props: {
            name: 'core/paragraph',
            attrs: {
                fontSize: 'small',
                align: 'center',
                content:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
            }
        }
    },
    {
        variant: 'Large Paragraph',
        props: {
            name: 'core/paragraph',
            attrs: {
                fontSize: 'large',
                content:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
            }
        }
    }
];
